<script lang="ts" setup>
import VbBackButton from "@/components/crud/VbBackButton.vue"
import VbDeleteButton from "@/components/crud/VbDeleteButton.vue"
import VbSaveButton from "@/components/crud/VbSaveButton.vue"
import { type Entity, injectMandatory, type ModuleConfiguration } from "@/vf"
import { computed, ref } from "vue"

const props = defineProps<{
    item: Entity
    saveDisabled?: boolean
}>()
const config = injectMandatory<ModuleConfiguration>("module-config", "VbEditToolbar must be used inside VbEdit")

const mode = computed(() => config.show?.page(props.item).mode)
const deleteConfirmBox = ref(undefined)
</script>

<template>
    <div>
        <div class="d-sm-flex justify-content-between">
            <div>
                <VbBackButton v-if="config.edit.backButton() && mode !== 'router'"></VbBackButton>
            </div>
            <div>
                <VbDeleteButton
                    v-if="config.edit.deleteButton(item)"
                    :confirm-teleport-target="deleteConfirmBox"
                ></VbDeleteButton>
            </div>
            <div>
                <VbSaveButton :disabled="saveDisabled"></VbSaveButton>
            </div>
        </div>
        <div ref="deleteConfirmBox"></div>
    </div>
</template>
